import "./App.css";

function App() {
  return (
    <div className="flex w-full flex-col items-center gap-3">
      <div className="w-[98%] rounded border border-slate-700 border-2 border-opacity-40 bg-gray-150 p-6 sm:w-[37rem]">
        <div className="w-auto mb-5 text-center">
          <span className="mb-4 text-2xl font-bold text-white rounded-xl border-2 border-transparent bg-slate-700 pl-6 pr-6 pt-2 pb-2">tv.cole.run</span>
        </div>
        <h1 className="mb-4 text-xl font-bold text-gray-300 text-center">A custom-built media sourcing engine for hi-res movies and tv shows.</h1>
        <hr className="mb-4 mt-5 border border-sky-500 border-slate-700" />
        <div className="flex w-full flex-col gap-1">
          <a href="https://plex.cole.run"><button
            type="button"
            className="
              mt-2 flex h-12 items-center overflow-hidden rounded-xl bg-sky-800 px-4 py-2 text-center text-white transition-[background-color,transform] hover:bg-sky-700 active:bg-sky-600 border-1 border-sky-500
              cursor-pointer w-full
            "
          >
            <p className="ml-auto mr-auto font-bold w-full">Watch on Plex&nbsp;&nbsp;&nbsp;➜</p>
          </button></a>
          <a href="https://plex-requests.cole.run"><button
            type="button"
            className="
              mt-2 flex h-12 items-center overflow-hidden rounded-xl bg-sky-800 px-4 py-2 text-center text-white transition-[background-color,transform] hover:bg-sky-700 active:bg-sky-600 border-1 border-sky-500
              cursor-pointer w-full
            "
          >
            <p className="ml-auto mr-auto font-bold w-full">Request Content&nbsp;&nbsp;&nbsp;➜</p>
          </button></a>
          <hr className="mb-4 mt-5 border border-slate-700 border-opacity-40" />
          <p className="mb-1 text-[0.98rem] font-bold text-gray-300/80 md:opacity-90">
            What is tv.cole.run?
          </p>
          <i className="mb-1 text-[0.98rem] text-gray-300/80 md:opacity-90">
            This API serves as the core media sourcing engine for content distributed through <a href="https://plex.cole.run" className="underline">plex.cole.run</a>. There are no plans for public access at this time.
          </i>
          <br />
          <p className="mb-1 text-[0.98rem] font-bold text-gray-300/80 md:opacity-90">
            What happened to my legacy "tv.cole.run" client account?
          </p>
          <i className="mb-1 text-[0.98rem] text-gray-300/80 md:opacity-90">
            Access to all content is now available through a new digital library powered by Plex (<a href="https://plex.cole.run" className="underline">plex.cole.run</a>) for improved device compatibility and efficiency.
            <br /><br />
            If you had a legacy client account on tv.cole.run, you can request access to the new digital library by sending an email to <a href="mailto:plex-invites@cole.run" className="underline">plex-invites@cole.run</a>.
          </i>
        </div>
      </div>
    </div>
  );
}

export default App;
